import { createMuiTheme } from '@material-ui/core/styles'

const muiTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: '"Poppins", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  palette: {
    primary: {
      main: '#00315D',
      contrastText: '#fff',
    },
    secondary: {
      main: '#4fcfdf',
      contrastText: '#fff',
    },
  },
})

export { muiTheme }
